module.exports = __webpack_public_path__ + "static/group-4a666e36aa93f1f21341e13329bb6353.jpg";